// Delivery-estimate behaviour. Idempotent so double-loads are harmless.
(function () {
  if (window.__aycanDeliveryInit) return;
  window.__aycanDeliveryInit = true;

  // Country selector: submit the localization form on change.
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (
      select &&
      select.classList &&
      select.classList.contains('aycan-delivery__select') &&
      select.form
    ) {
      select.form.submit();
    }
  });

  // Turn business-day windows into concrete arrival date ranges, client-side,
  // so it reflects the visitor's real "today" even on cached pages. Weekends
  // are skipped; public holidays are not modelled — hence "estimated". The
  // business-day count stays available on the element's title attribute, and
  // is the no-JS fallback text.
  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added += 1;
    }
    return d;
  }

  function renderDates() {
    var lang = document.documentElement.lang || 'en';
    var opts = { month: 'short', day: 'numeric' };
    var today = new Date();
    var spans = document.querySelectorAll('.aycan-delivery__range[data-days-min]');
    for (var i = 0; i < spans.length; i++) {
      var el = spans[i];
      var min = parseInt(el.getAttribute('data-days-min'), 10);
      var max = parseInt(el.getAttribute('data-days-max'), 10);
      if (isNaN(min) || isNaN(max)) continue;
      var d1 = addBusinessDays(today, min);
      var d2 = addBusinessDays(today, max);
      var s1;
      var s2;
      try {
        s1 = d1.toLocaleDateString(lang, opts);
        s2 = d2.toLocaleDateString(lang, opts);
      } catch (e) {
        s1 = d1.toLocaleDateString('en', opts);
        s2 = d2.toLocaleDateString('en', opts);
      }
      el.textContent = s1 + ' – ' + s2;
    }
  }

  renderDates();
})();
